export enum HydrateSource {
  CANCELED_APPLICATION = 'CANCELED_APPLICATION',
  MAIL_CODE = 'MAIL_CODE',
  PREVIEW = 'PREVIEW',
  SIGN_UP = 'SIGN_UP',
  VEHICLE_SELECTION = 'VEHICLE_SELECTION',
}
